module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "About",
    attrs: {
      "onclick": "_hmt.push(['_trackEvent', 'website', 'click', '点击'])"
    }
  }, [_c('meta', {
    attrs: {
      "name": "keywords",
      "content": "以诺教育，高端教育，海外游学；斯坦福；以色列"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "name": "description",
      "content": "以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"
    }
  }), _vm._v(" "), _c('title', [_vm._v("关于以诺-以诺教育")]), _vm._v(" "), _c('headTop'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('Bottom')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "AboutEnoch"
  }, [_c('div', {
    staticClass: "zhContents"
  }, [_c('div', {
    staticClass: "zhFloating"
  }, [_c('div', {
    staticClass: "zhList1"
  }, [_c('span', {
    staticClass: "zhYinuo"
  }, [_vm._v("关于以诺")])]), _vm._v(" "), _c('div', {
    staticClass: "zhList"
  }, [_c('span', {
    staticClass: "zhYinuo zhShu"
  }, [_vm._v("源起")])]), _vm._v(" "), _c('div', {
    staticClass: "zhList"
  }, [_c('span', {
    staticClass: "zhYinuo"
  }, [_vm._v("校长寄语")])]), _vm._v(" "), _c('div', {
    staticClass: "zhList"
  }, [_c('span', {
    staticClass: "zhYinuo"
  }, [_vm._v("愿景与使命")])]), _vm._v(" "), _c('div', {
    staticClass: "zhList"
  }, [_c('span', {
    staticClass: "zhYinuo"
  }, [_vm._v("我们的服务")])])]), _vm._v(" "), _c('div', {
    staticClass: "zhOrigin"
  }, [_c('div', {
    staticClass: "zhNR"
  }, [_c('i', [_vm._v("源")]), _vm._v(" "), _c('i', [_vm._v("起")])]), _vm._v(" "), _c('div', {
    staticClass: "zhDown"
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhOriginCon"
  }, [_c('div', {
    staticClass: "zhOriginConList"
  }, [_c('div', {
    staticClass: "zhOM"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/originicon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zhP"
  }, [_vm._v("创业初心")]), _vm._v(" "), _c('div', {
    staticClass: "zhOriginLeft"
  }, [_c('div', {
    staticClass: "zhLeftM"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/originicon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "zhBT"
  }, [_vm._v("创业初心")]), _vm._v(" "), _c('p', {
    staticClass: "zhJG"
  }), _vm._v(" "), _c('p', {
    staticClass: "zhBTCon"
  }, [_vm._v("以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。")])])])]), _vm._v(" "), _c('div', {
    staticClass: "zhOriginConList"
  }, [_c('div', {
    staticClass: "zhOM"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/originpp.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zhP"
  }, [_vm._v("品牌寓意")]), _vm._v(" "), _c('div', {
    staticClass: "zhOriginLeft zhOriginLeft2"
  }, [_c('div', {
    staticClass: "zhLeftM"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/originpp.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "zhBT"
  }, [_vm._v("品牌寓意")]), _vm._v(" "), _c('p', {
    staticClass: "zhJG"
  }), _vm._v(" "), _c('p', {
    staticClass: "zhBTCon"
  }, [_vm._v("“以诺”的英文“Enoch”源于希腊语Eunoia，意为Beautiful Thinking（美妙的思维）。在《圣经》中，Enoch是一个得神喜悦和恩典的人，代表三大含义：开端、奉献、教师。他发明了许多实用的学问，直到现在还被人们所使用，例如书写、数学、天文学等")])])])]), _vm._v(" "), _c('div', {
    staticClass: "zhOriginConList"
  }, [_c('div', {
    staticClass: "zhOM"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/originfz.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zhP"
  }, [_vm._v("发展历史")]), _vm._v(" "), _c('div', {
    staticClass: "zhOriginLeft zhOriginLeft3"
  }, [_c('div', {
    staticClass: "zhLeftM"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/originfz.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "zhBT"
  }, [_vm._v("发展历史")]), _vm._v(" "), _c('p', {
    staticClass: "zhJG"
  }), _vm._v(" "), _c('p', {
    staticClass: "zhBTCon"
  }, [_vm._v("经过3年，以诺教育完成了100多次海内外高端游学课程，如名闻遐尔的《以色列创智之旅》和引领国内高净值财富管理课程的《财富学堂》。4000多名中国高净值人士在以诺教育的带领下，在全球完成了一次次学习之旅。诚如诺亚财富创始人、董事局主席兼CEO汪静波女士所言：“在任何市场环境下，学习，是对自己最好的投资。”")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "zhOrigin"
  }, [_c('div', {
    staticClass: "zhNR"
  }, [_c('i', [_vm._v("校")]), _vm._v(" "), _c('i', [_vm._v("长")]), _vm._v(" "), _c('i', [_vm._v("寄")]), _vm._v(" "), _c('i', [_vm._v("语")])]), _vm._v(" "), _c('div', {
    staticClass: "zhDown",
    staticStyle: {
      "width": "154px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhPresident"
  }, [_c('div', {
    staticClass: "zhPreLeft"
  }, [_c('p', {
    staticClass: "zhPreWord"
  }, [_vm._v("世界上有很多人，他们衣食无忧，但内心依然觉得欠缺，他们反复思索着生命的激情和意义。也有一些人，突破思想的牢笼，身体力行，对自己的人生永无止境、无惧无畏地探寻。")]), _vm._v(" "), _c('p', {
    staticClass: "zhPreWord"
  }, [_vm._v("古希腊先贤苏格拉底有句名言：“认识你自己！”认识自己就是认识我们内在的心灵。在当今充满复杂、冲突以及快速创新的世界，我们每个人都要思考：如何学习成长？如何度过有品质的一生？")]), _vm._v(" "), _c('p', {
    staticClass: "zhPreWord"
  }, [_vm._v("“格物、致知、诚意、正心、修身、齐家、治国、平天下”这短短17个字，代表了中国传统文化中个人修行之路的精髓。也说明，学习不仅需要头脑的思考，更需要身体的亲历和灵魂的沉浸。")]), _vm._v(" "), _c('p', {
    staticClass: "zhPreWord"
  }, [_vm._v("以诺教育遵从古希腊哲学中的共善和普世精神，提供心灵扩展和启明之博雅教育。通过科学、系统、深入地洞察客户需求，嫁接全球最高端的教育资源，精准地匹配教育产品与客户需求，成为高端学习生活的导航者。")]), _vm._v(" "), _c('p', {
    staticClass: "zhPreWord"
  }, [_vm._v("以诺，在路上！")])]), _vm._v(" "), _c('div', {
    staticClass: "zhPreRight"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Principal.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhPreBottom"
  }, [_vm._v("以诺教育创始人、董事长")]), _vm._v(" "), _c('img', {
    staticClass: "zhServiceImg",
    attrs: {
      "src": require("../../assets/autograph.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhOrigin"
  }, [_c('div', {
    staticClass: "zhNR"
  }, [_c('i', [_vm._v("愿")]), _vm._v(" "), _c('i', [_vm._v("景")]), _vm._v(" "), _c('i', [_vm._v("与")]), _vm._v(" "), _c('i', [_vm._v("使")]), _vm._v(" "), _c('i', [_vm._v("命")])]), _vm._v(" "), _c('div', {
    staticClass: "zhDown",
    staticStyle: {
      "width": "196px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhMission"
  }, [_c('div', {
    staticClass: "zhMissionLeft"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../../assets/zhxiu.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zhMissionCon"
  }, [_c('p', {
    staticClass: "zhMissionYY"
  }, [_vm._v("我们的愿景")]), _vm._v(" "), _c('p', {
    staticClass: "zhHG"
  }), _vm._v(" "), _c('p', {
    staticClass: "zhHGCon"
  }, [_vm._v("知识丰盈人生财富，学习创造价值与感动")])])]), _vm._v(" "), _c('div', {
    staticClass: "zhMissionLeft"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../../assets/president1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zhMissionCon"
  }, [_c('p', {
    staticClass: "zhMissionYY"
  }, [_vm._v("我们的使命")]), _vm._v(" "), _c('p', {
    staticClass: "zhHG"
  }), _vm._v(" "), _c('p', {
    staticClass: "zhHGCon"
  }, [_vm._v("创建中国知名的教育文化品牌，以终生学习的场域，为个人、家族、企业提供有形、无形财富知识服务。")])])])]), _vm._v(" "), _c('div', {
    staticClass: "zhOrigin"
  }, [_c('div', {
    staticClass: "zhNR"
  }, [_c('i', [_vm._v("我")]), _vm._v(" "), _c('i', [_vm._v("们")]), _vm._v(" "), _c('i', [_vm._v("的")]), _vm._v(" "), _c('i', [_vm._v("服")]), _vm._v(" "), _c('i', [_vm._v("务")])]), _vm._v(" "), _c('div', {
    staticClass: "zhDown",
    staticStyle: {
      "width": "196px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "zhService"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/service.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "zhSerCon"
  }, [_vm._v("围绕高净值客户和企业家个人、家庭和企业全方位学习和增长智慧的需求，以诺教育目前提供涵盖投资理财、企业管理、亲子教育、心灵成长、自然人文五大主题课程。此外，以诺教育还为特定团体或机构定制主题班，帮助企业或团体提升凝聚力、协作力，开拓视野。")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19def79b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutEnoch/AboutEnoch.vue
// module id = 546
// module chunks = 1